type ClassValue =
  | string
  | number
  | null
  | false
  | undefined
  | Record<string, boolean | null | undefined>
  | ClassValue[];

function classOf(arg: ClassValue): string {
  if (!arg) return '';
  if (typeof arg === 'string' || typeof arg === 'number') return String(arg);
  if (Array.isArray(arg)) return classNames(...arg);
  return Object.keys(arg)
    .filter((k) => arg[k])
    .join(' ');
}

export function classNames(...args: ClassValue[]): string {
  return args.map(classOf).filter(Boolean).join(' ');
}
